import { GeneralInputProps } from '@/components/GeneralInputs/type';
import {
  FormInputNumber,
  FormInputNumberProps,
} from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { memo, useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

export type NumericTypeProps<TFieldValues extends FieldValues> =
  FormInputNumberProps<TFieldValues>;

type NumericTypeInputProps<TFieldValues extends FieldValues> =
  NumericTypeProps<TFieldValues> & GeneralInputProps;

const InnerNumericTypeInput = <TFieldValues extends FieldValues>({
  control,
  inputId,
  rules,
  inputProps: _inputProps,
  name,
  onChangeAfter,
  placeholder,
}: NumericTypeInputProps<TFieldValues>) => {
  const inputProps = useMemo(() => {
    return {
      ..._inputProps,
      placeholder: placeholder,
    };
  }, [placeholder, _inputProps]);

  return (
    <div className={cx(styles['numeric_type_container'])}>
      <FormInputNumber<TFieldValues>
        control={control}
        inputId={inputId}
        rules={rules}
        inputProps={inputProps}
        name={name}
        onChangeAfter={onChangeAfter}
      />
    </div>
  );
};
InnerNumericTypeInput.displayName = 'InnerNumericTypeInput';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const NumericTypeInput = memo(
  InnerNumericTypeInput
) as typeof InnerNumericTypeInput;
NumericTypeInput.displayName = 'NumericTypeInput';
